import { Component, OnInit } from '@angular/core';
import { Routes, Router } from '@angular/router';

import { UbiMenuService } from './theme';
import { PAGES_MENU } from './app.menu';
import { AuthenticationService } from './auth/index';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  user = '';
  options: any;

  constructor(private menuService: UbiMenuService, private authenticationService: AuthenticationService,
    private router: Router) {
  }

  ngOnInit() {

    //this.menuService.updateMenuByRoutes(<Routes>PAGES_MENU);
    this.options = { copyright: true, status: true, photo: false, msgcenter: { messages: false, notifications: false } };

    localStorage.removeItem('auth_token');

    this.authenticationService.getUser().subscribe(user => {
      this.user = user;
      this.menuService.updateMenuByRoutes(<Routes>PAGES_MENU);
      this.router.navigate(['/']);
    });

  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/app.component.ts